import { Panel } from '../ui/Panel';
import { ContentEditor } from '../ui/ContentEditor';
import { useSettings } from './useSettings';

/** Instellingen › Cadeaus & codes › Codes: klantcodes voor attributie en de klanten die hun routine delen. */
export function CodeSettings() {
  const {
    json
  } = useSettings();
  return <>
      <Panel title="Klantcodes" description="Om bij te houden via wie een bestelling binnenkomt. Een code geeft nooit korting. Doet een code echt iets (zoals SALON), zet dat dan bij “Wat de code doet”; anders leeg laten. Het reisformaat komt via de cadeaustaffel, niet via een code." data-id="element-4131" data-mp="3c91i13xtpvmn">
        <ContentEditor {...json('codes')} fieldKey="codes" data-id="element-4132" data-mp="3q8jbvxpz7z2v" />
      </Panel>
      <Panel title="Vaste cliënten" description="Hun zin en favoriete product staan bij de reviews op de homepage en op de pagina van dat product. Elke cliënt heeft een eigen code, alleen om bij te houden via wie iemand kwam." data-id="element-4133" data-mp="3v85n61m8v591">
        <ContentEditor {...json('creators')} fieldKey="creators" data-id="element-4134" data-mp="rkwwyebm1oqr" />
      </Panel>
    </>;
}